import { render, staticRenderFns } from "./intro-db.vue?vue&type=template&id=191e61cc&scoped=true&"
import script from "./intro-db.vue?vue&type=script&lang=js&"
export * from "./intro-db.vue?vue&type=script&lang=js&"
import style0 from "./intro-db.vue?vue&type=style&index=0&id=191e61cc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191e61cc",
  null
  
)

export default component.exports